import React, { useState } from "react";
import axios from "axios";
import "./CreateAdmin.css";
import { NavLink } from "react-router-dom";
import loogoo from "../Components/Header/assets/images/logo.png";
const CreateAdmin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/create-admin`,
        { username, password },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

        }
      
      );
          window.location.href = "/admin-login";

      setMessage(data.message);
      setUsername("");
      setPassword("");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to create admin");
    }
  };

  return (
    <div className="create-admin-container">
       <div> 
             <NavLink to="/">
            <img
              loading="lazy"
              src={loogoo}
              alt="Iskcon Vijayawada Logo"
              className="iskcon-loogoo"
            />
          </NavLink>
          </div>

      <h2 style={{color : "#ffff"}}>Create New Admin</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="New Admin Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="New Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Create Admin</button>
      </form>
      <button className="back-btn" onClick={() => window.location.href = "/iskconCMS"}>Back to iskconCMS</button>
      {message && <p className="msg">{message}</p>}
    </div>
  );
};

export default CreateAdmin;
